import React from 'react';
import PropTypes from 'prop-types';

const Buttons = ({ name  ,  id, children, type, className, onClick, disabled, dataBsTarget, dataBsToggle, dataBsDismiss, ariaExpanded }) => {
  return (
    <>
      <button id={id} className={className} type={type} onClick={onClick} disabled={disabled} data-bs-target={dataBsTarget} data-bs-toggle={dataBsToggle} data-bs-dismiss={dataBsDismiss} aria-expanded={ariaExpanded}>
        {children}{name}
      </button>
    </>
  );
};

Buttons.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  dataBsTarget: PropTypes.string,
  dataBsToggle: PropTypes.string,
  dataBsDismiss: PropTypes.string,
  ariaExpanded: PropTypes.bool 
};

export default Buttons;
